import { Box, Container, Typography } from '@fe-toolkit/web-components/ssr'

export function LegalDisclaimerBanner() {
  return (
    <Box backgroundColor="black" padding="large" sx={{ marginBottom: '1px' }}>
      <Container>
        <Box sx={({ theme }) => ({ maxWidth: theme.layout.readableWidth })}>
          <Typography as="p" color="white" variant="whisperLoud">
            Terms and conditions
          </Typography>
          <Typography as="p" color="white" variant="whisper">
            Ends 30/10. 24 month plans only. Up to £300 bill credit towards eligible broadband early termination fees
            only. Claim within 60 days of activation with final bill. Credit applied as a lump sum after 2 Successful
            Payments. Terms and exclusions apply, see{' '}
            <Typography
              as="a"
              color="white"
              href="https://www.giffgaff.com/terms/promotions#contract-buyout"
              rel="noopener noreferrer"
              target="_blank"
              variant="whisperLoud"
            >
              here
            </Typography>
          </Typography>
        </Box>
      </Container>
    </Box>
  )
}
